<template>
  <div class="row">
    <div class="col-lg-6 col-md-6 col-xl-6 mb-5">
      <div class="card card-custom gutter-b">
        <div class="card-header">
          <div class="card-title">
            <h3 class="card-label">{{ $t('general.filter') }}</h3>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-lg-4 col-xl-4">
              <b-form-group :label="$t('users.start_date')" label-for="input-2">
                <b-form-input
                    class="form-control form-control-solid"
                    type="date"
                    required
                    :placeholder="$t('users.start_date')"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-lg-4 col-xl-4">
              <b-form-group :label="$t('users.end_date')" label-for="input-2">
                <b-form-input
                    class="form-control form-control-solid"
                    type="date"
                    required
                    :placeholder="$t('users.end_date')"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-lg-4 col-xl-4">
              <b-form-group id="input-group-4" :label="$t('contact_requests.status')" label-for="input-3">
                <b-form-select
                    class="form-control form-control-solid"
                    v-model="form.status"
                    :options="status"
                ></b-form-select>
              </b-form-group>
            </div>
            <div class="col-lg-4 col-xl-4">
              <b-form-group id="input-group-4" :label="$t('contact_requests.titles')" label-for="input-3">
                <b-form-select
                    class="form-control form-control-solid"
                    v-model="form.titles"
                    :options="titles"
                ></b-form-select>
              </b-form-group>
            </div>
            <div class="col-lg-4 col-xl-4">
              <b-form-group :label="$t('users.member_id')">
                <b-form-input id="input-none" class="form-control form-control-solid" :placeholder="$t('users.member_id')"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-lg-4 col-xl-4">
              <b-form-group :label="$t('users.email')">
                <b-form-input id="input-none" class="form-control form-control-solid" :placeholder="$t('users.email')"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-lg-4 col-xl-4">
              <b-form-group :label="$t('contact_requests.answers')">
                <b-form-checkbox-group id="checkbox-group-2" v-model="form.selected" name="flavour-2">
                  <b-form-checkbox value="orange">{{ $t('general.yes') }}</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <span class="fa-pull-right">
            <button type="reset" class="btn btn-outline-primary mr-10">{{ $t('general.clear') }}</button>
            <button type="submit" class="btn btn-primary">{{ $t('general.filter_') }}</button>
          </span>
        </div>
      </div>
    </div>
    <div class="col-lg-6 col-md-6 col-xl-6 mb-5">
      <div class="card card-custom gutter-b">
        <div class="card-header">
          <div class="card-title">
            <h3 class="card-label">{{ $t('contact_requests.reply_to_selected') }}</h3>
          </div>
          <div class="card-toolbar">
            <b-button size="sm" class="btn btn-primary card-header-right font-weight-bold py-3 px-6" v-b-modal.manage_messages>
              <i class="fas fa-list-ul"></i>{{ $t('contact_requests.shortcut_messages') }}
            </b-button>

            <b-modal size="lg" id="manage_messages" :cancel-title="$t('general.cancel')" :ok-title="$t('general.save')" :title="$t('contact_requests.shortcut_messages')">
              <b-list-group>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <strong>İptal</strong>
                  <div class="mt-3">
                    <b-button-group size="sm">
                      <b-button v-b-modal.create_message><i class="fa fa-edit"></i> {{$t('general.edit')}}</b-button>
                      <b-button><i class="fa fa-trash"></i> {{$t('general.delete')}}</b-button>
                    </b-button-group>
                  </div>
                </b-list-group-item>

                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <strong>Tamamlandı</strong>
                  <div class="mt-3">
                    <b-button-group size="sm">
                      <b-button v-b-modal.create_message><i class="fa fa-edit"></i> {{$t('general.edit')}}</b-button>
                      <b-button><i class="fa fa-trash"></i> {{$t('general.delete')}}</b-button>
                    </b-button-group>
                  </div>
                </b-list-group-item>

                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <strong>Beklemede</strong>
                  <div class="mt-3">
                    <b-button-group size="sm">
                      <b-button v-b-modal.create_message><i class="fa fa-edit"></i> {{$t('general.edit')}}</b-button>
                      <b-button><i class="fa fa-trash"></i> {{$t('general.delete')}}</b-button>
                    </b-button-group>
                  </div>
                </b-list-group-item>

              </b-list-group>
            </b-modal>
          </div>
        </div>
        <div class="card-body">
          <b-form-group :label="$t('contact_requests.shortcut_messages')">
            <b-row>
              <b-col md="5">
                <b-form-input
                    placeholder="Kısa kodu giriniz"
                    v-model="shortcut_code"
                ></b-form-input>
              </b-col>
              <b-col md="2 text-center mt-3">ya da</b-col>
              <b-col md="5">
                <b-form-select
                    @change="changeIt($event,'shortcut_messages')"
                    id="selected_shortcut_message"
                    v-model="selected_shortcut_message"
                    :options="shortcut_messages" size="sm">
                </b-form-select>
              </b-col>
            </b-row>
          </b-form-group>

          <b-form-group :label="$t('contact_requests.answer')">
            <b-form-textarea
                id="answer"
                :placeholder="$t('contact_requests.answer')"
                rows="4"
                max-rows="7"
                :value="message"
            ></b-form-textarea>
          </b-form-group>

          <b-modal id="create_message" ref="my-modal" :cancel-title="$t('general.cancel')" :ok-title="$t('general.save')" :title="$t('contact_requests.shortcut_messages')">
            <div class="d-block text-center">
              <b-row>
                <b-col sm="2">Mesaj Başlığı</b-col>
                <b-col sm="10">
                  <b-form-input
                      id="input-1"
                      type="text"
                      required
                      placeholder="Mesaj başlığı giriniz."
                  ></b-form-input>
                </b-col>
              </b-row>
              <br>
              <b-row>
                <b-col sm="2">
                  <label for="answer">{{ $t('contact_requests.answer') }}:</label>
                </b-col>
                <b-col sm="10">
                  <b-form-textarea
                      id="answer"
                      :placeholder="$t('contact_requests.answer')"
                      rows="3"
                      max-rows="8"
                  ></b-form-textarea>
                </b-col>
              </b-row>
            </div>
          </b-modal>
        </div>
        <div class="card-footer">
          <span class="fa-pull-right">
            <button type="submit" class="btn btn-outline-success mr-10"><i class="far fa-file-excel"></i> {{ $t('contact_requests.import_excel') }}</button>
            <button type="submit" class="btn btn-primary">{{ $t('general.update') }}</button>
          </span>
        </div>
      </div>
    </div>
    <div class="col-lg-12 col-xl-12 mb-5">
      <dashboard-box :title="$t('menu.contact_requests')">
        <template v-slot:preview>
          <data-table
              :items="table.items"
              :fields="report.fields"
              :paginate="report.paginate"
              page.sync="3"
              perPage.sync="10"
          ></data-table>
        </template>
      </dashboard-box>
    </div>
  </div>
</template>

<script>
import DataTable from "@/assets/components/dataTable/DataTable";
import DashboardBox from "@/assets/components/DashboardBox";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "ContactRequests",
  components: { DataTable, DashboardBox },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.name = "";
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },

    changeIt(data,input) {
      if (data == "Yeni Mesaj Oluştur"){
        this.$refs['my-modal'].show()
        this.message = "";
      }
      if (data == "İptal") {
        this.message = 'İptal talebiniz gerçekleştirilerek Napolyon\'da bulunan kişisel bilgileriniz silinmiştir. Bununla beraber sitemize üyelik davet yöntemiyle olduğu için bilgimiz dışında bir arkadaşınız tarafından Napolyon\'a davet mesajı alabilirsiniz.'
      }else{
        this.message = '';
      }

      if (input == 'shortcut_code'){
        if (data == '1ip'){
          this.message = 'İptal talebiniz gerçekleştirilerek Napolyon\'da bulunan kişisel bilgileriniz silinmiştir. Bununla beraber sitemize üyelik davet yöntemiyle olduğu için bilgimiz dışında bir arkadaşınız tarafından Napolyon\'a davet mesajı alabilirsiniz.'
        }
      }

    },
  },
  data() {
    return {
      form : {
        status : 'Yeni',
        titles : 'Diğer',
        selected : null,
      },
      shortcut_code : '',
      report : {
        paginate : {
          next_page_url: "#",
          path: "#",
          per_page: 15,
          prev_page_url: null,
          to: 15,
          total: 48,
          pageNumberProxy:1,
          current_page : 1,
          first_page_url: "http://127.0.0.1:8000/api/samples?page=1",
          from: 1,
          last_page: 20,
          last_page_url: "http://127.0.0.1:8000/api/samples?page=2",
          links: [
            {
              "url": null,
              "label": "&laquo; Öncekiler",
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=1",
              "label": 1,
              "active": true
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": 2,
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": "Sonrakiler &raquo;",
              "active": false
            }
          ],
        },
        fields: [
          {key: 'checkbox', label: '', sortable: false},
          {key: 'member_id', label: 'Member ID', sortable: false},
          {key: 'firstname', label: 'Ad', sortable: true},
          {key: 'lastname', label: 'Soyad', sortable: true},
          {key: 'email', label: 'Email', sortable: true},
          {key: 'phone', label: 'Telefon', sortable: true},
          {key: 'subject', label: 'Konu', sortable: false},
          {key: 'message', label: 'Mesaj', sortable: false},
          {key: 'created_at', label: 'Oluşturulma Tarihi', sortable: true},
          {key: 'ip', label: 'IP', sortable: true},
          {key: 'attachment', label: 'Ek', sortable: true}
        ],
      },
      table : {
        items : [
          {'member_id' : '3871304', 'firstname' : 'Serdar', 'lastname' : 'Mermer', 'email' : 'serdarmermer@gmail.com', 'phone' : '0555 555 55 55', 'subject' : 'Üyelik İptali', 'message' : 'Hoşuma gitmedi. Üyeliğim kapatılsın.', 'ip' : '178.247.13.19','attachment' : '-', 'created_at' : '4.01.2021 19:40'},
          {'member_id' : '3871303', 'firstname' : 'Musa', 'lastname' : 'Turhan', 'email' : 'musaturhan@gmail.com', 'phone' : '0555 444 44 44', 'subject' : 'Satış', 'message' : 'Nasıl ödeme alırım?', 'ip' : '444.247.33.19','attachment' : '-', 'created_at' : '1.02.2021 19:40'},
       ],
      },
      status: ['Yeni', 'Silindi', 'Tamamlandı', 'Beklemede'],
      titles: ['Kampanyalar', 'Öneri', 'Profil Bilgileri', 'Sosyal Sorumluk', 'Teşekkür', 'Siteye Giriş Sorunları', 'Anketler', 'Arkadaş Daveti', 'Nap Puan Transferleri', 'Üyelik İptali', 'Diğer'],
      shortcut_messages : ['İptal', 'Tamamlandı', 'Beklemede', 'Yeni Mesaj Oluştur'],
      selected_shortcut_message : 'İptal',
      message : 'İptal talebiniz gerçekleştirilerek Napolyon\'da bulunan kişisel bilgileriniz silinmiştir. Bununla beraber sitemize üyelik davet yöntemiyle olduğu için bilgimiz dışında bir arkadaşınız tarafından Napolyon\'a davet mesajı alabilirsiniz.'
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t('general.project_2') },
      { title: this.$t('menu.contact_requests') }
    ]);
  },
  watch: {
    shortcut_code: function (val) {
      if (val == '1ip'){
        this.message = 'İptal talebiniz gerçekleştirilerek Napolyon\'da bulunan kişisel bilgileriniz silinmiştir. Bununla beraber sitemize üyelik davet yöntemiyle olduğu için bilgimiz dışında bir arkadaşınız tarafından Napolyon\'a davet mesajı alabilirsiniz.'
      }else{
        this.message = ""
      }
    }
  }
}
</script>

<style scoped>

</style>
